import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ShieldCheck, ArrowRight, ExternalLink } from 'lucide-react';
import { certificationsData } from '../data/certifications';
export function CertificationsPage() {
  return <>
      <PageHero label="About Us" title="Certifications & Accreditations" subtitle="Our commitment to quality, security, and environmental standards is verified by leading accreditation bodies." data-id="element-510" />

      <Breadcrumbs items={[{
      label: 'About Us',
      to: '/about'
    }, {
      label: 'Certifications'
    }]} data-id="element-511" />

      {/* Summary Cards Section */}
      <section className="bg-slate-50 py-24 border-b border-steel-200" data-id="element-512">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-513">
          <div className="mb-12" data-id="element-514">
            <h2 className="text-3xl font-bold text-navy-900 mb-4" data-id="element-515">
              Key certificates & accreditations
            </h2>
            <p className="text-lg text-steel-600" data-id="element-516">
              A quick overview of our primary certifications and memberships.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-517">
            {certificationsData.map(card => <div key={card.id} className="bg-white border border-steel-200 rounded-sm overflow-hidden hover:border-cg-orange-600 transition-colors group flex flex-col" data-id="element-518">
                {/* Placeholder for Logo/Thumbnail */}
                <div className="h-32 bg-slate-100 flex items-center justify-center border-b border-steel-100" data-id="element-519">
                  <ShieldCheck className="w-12 h-12 text-steel-300 group-hover:text-cg-orange-600 transition-colors" data-id="element-520" />
                </div>

                <div className="p-6 flex flex-col flex-1" data-id="element-521">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-cg-orange-600 mb-2" data-id="element-522">
                    {card.type}
                  </span>
                  <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-523">
                    {card.title}
                  </h3>
                  <p className="text-sm text-steel-600 mb-4 flex-1" data-id="element-524">
                    {card.descriptor}
                  </p>

                  <div className="text-xs text-steel-500 mb-6 pb-6 border-b border-steel-100" data-id="element-525">
                    <span className="font-semibold text-navy-900" data-id="element-526">
                      {card.type === 'Membership' ? 'Managed by:' : 'Issued by:'}
                    </span>{' '}
                    {card.issuedBy}
                  </div>

                  <div className="flex flex-col gap-4 mt-auto" data-id="element-527">
                    {card.externalLink ? <a href={card.externalLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider text-sm rounded-sm transition-colors w-full gap-2" data-id="element-528">
                        Learn more <ExternalLink className="w-4 h-4" data-id="element-529" />
                      </a> : <Link to={`/about/certifications/${card.id}`} className="inline-flex items-center justify-center px-6 py-3 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider text-sm rounded-sm transition-colors w-full gap-2" data-id="element-530">
                        View details <ArrowRight className="w-4 h-4" data-id="element-531" />
                      </Link>}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}